import { Alert, Grid } from '@mui/material';
import React from 'react';

const ExportRequestsAlert = ({ exportRequests, projects }) => {
  const renderProjects = (projectIds) => {
    return (
      projectIds &&
      projectIds
        .map(
          (id) => projects.find((p) => p.id === id)?.name || 'Unknown Project'
        )
        .join(', ')
    );
  };

  if (!exportRequests || exportRequests.length === 0) return null;

  const inProgressRequests = exportRequests.filter(
    (request) => request.status === 'requested'
  );
  const completedRequests = exportRequests.filter(
    (request) => request.status === 'completed'
  );

  return (
    <Grid item xs={12}>
      {completedRequests.length > 0 && (
        <Alert severity="success" sx={{ color: '#388e3c', p: 2 }}>
          <strong>
            Your exported data is now ready to download. The file will be
            available for download for 7 days.
          </strong>
          <br />
          {completedRequests.map((request, index) => (
            <React.Fragment key={request.id}>
              <div
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}>
                <strong>Export #{index + 1}:</strong>{' '}
                <span style={{ fontSize: '0.9em' }}>
                  Request Time:{' '}
                  {new Date(request.export_requested_date).toLocaleString()}
                </span>
              </div>
              <div>{renderProjects(request.project_id)}</div>
              <a href={request.export_link} download>
                Download
              </a>{' '}
              <br />
            </React.Fragment>
          ))}
        </Alert>
      )}
      {inProgressRequests.length > 0 && (
        <Alert severity="info" sx={{ color: '#1976d2', p: 2 }}>
          <strong>Your export request has been received.</strong>
          <br />
          The data for the following projects is currently being prepared:
          <br />
          {inProgressRequests.map((request, index) => (
            <React.Fragment key={request.id}>
              <div
                style={{
                  marginTop: '10px',
                  display: 'flex',
                  justifyContent: 'space-between',
                }}>
                <strong>Export Request #{index + 1}: </strong>
                <span style={{ fontSize: '0.9em' }}>
                  Request Time:{' '}
                  {new Date(request.export_requested_date).toLocaleString()}
                </span>
              </div>
              <span>{renderProjects(request.project_id)}</span>
            </React.Fragment>
          ))}
          <div style={{ marginTop: '10px' }}>
            We’ll notify you by email once the data is ready for download.
          </div>
        </Alert>
      )}
    </Grid>
  );
};

export default ExportRequestsAlert;
